import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCircle, faSquare, faTriangle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type CustomIconProps = {
    icon: IconProp;
    size?: string;
    color?: string;
    style?: React.CSSProperties;
    shrink?: number;
    transform?: string;
};

export const CircleIcon: React.FC<CustomIconProps> = ({ icon, size = '3xl', style, shrink = 8, transform }) => {
    return (
        <span className={`fa-layers fa-fw ${size}`} style={style}>
            <FontAwesomeIcon className="gradient text-transparent rounded-full h-8" icon={faCircle} />
            <FontAwesomeIcon icon={icon} inverse transform={`shrink-${shrink} ${transform}`} />
        </span>
    );
};

export const RoundedSquareIcon: React.FC<CustomIconProps> = ({
    icon,
    color = 'gradient',
    style,
    shrink = 8,
    transform,
}) => {
    return (
        <span className="fa-layers fa-fw text-3xl" style={style}>
            <FontAwesomeIcon className={`${color} text-transparent rounded-lg h-7 w-7`} icon={faSquare} />
            <FontAwesomeIcon icon={icon} transform={`shrink-${shrink} ${transform}`} inverse />
        </span>
    );
};

export const TriangleIcon: React.FC<CustomIconProps> = ({ icon, color = 'gradient', style, shrink = 9, transform }) => {
    return (
        <span className="fa-layers fa-fw text-3xl" style={style}>
            <FontAwesomeIcon className={`${color}`} icon={faTriangle} />
            <FontAwesomeIcon icon={icon} transform={`shrink-${shrink} down-2 ${transform}`} />
        </span>
    );
};
